//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_REMOTE_SERVICES_BASE_URL = new InjectionToken<string>('API_REMOTE_SERVICES_BASE_URL');

export interface IDTechRemoteService {
    getDTechRemoteList(runningOnly: boolean | undefined, connectedOnly: boolean | undefined, acceptedConsentOnly: boolean | undefined, activatedOnly: boolean | undefined, page: number | undefined, pageSize: number | undefined, qSearch: string | null | undefined): Observable<PagedRemoteServiceListDto>;
    exportDTechRemoteList(format: RemoteServiceListExportFormat | undefined, runningOnly: boolean | undefined, connectedOnly: boolean | undefined, acceptedConsentOnly: boolean | undefined, activatedOnly: boolean | undefined, qSearch: string | null | undefined): Observable<FileResponse>;
    getDTechRemoteById(remoteServiceId: string): Observable<RemoteServiceListItemDto>;
    addDTechRemoteService(vin: string | undefined): Observable<AddRemoteServiceDto>;
    initiateDTechRemoteSession(remoteServiceId: string, command: InitiateDTechRemoteSessionCommand): Observable<void>;
    terminateDTechRemoteSession(remoteServiceId: string, command: TerminateDTechRemoteSessionCommand): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class DTechRemoteService implements IDTechRemoteService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REMOTE_SERVICES_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDTechRemoteList(runningOnly: boolean | undefined, connectedOnly: boolean | undefined, acceptedConsentOnly: boolean | undefined, activatedOnly: boolean | undefined, page: number | undefined, pageSize: number | undefined, qSearch: string | null | undefined): Observable<PagedRemoteServiceListDto> {
        let url_ = this.baseUrl + "/DTechRemote?";
        if (runningOnly === null)
            throw new globalThis.Error("The parameter 'runningOnly' cannot be null.");
        else if (runningOnly !== undefined)
            url_ += "runningOnly=" + encodeURIComponent("" + runningOnly) + "&";
        if (connectedOnly === null)
            throw new globalThis.Error("The parameter 'connectedOnly' cannot be null.");
        else if (connectedOnly !== undefined)
            url_ += "connectedOnly=" + encodeURIComponent("" + connectedOnly) + "&";
        if (acceptedConsentOnly === null)
            throw new globalThis.Error("The parameter 'acceptedConsentOnly' cannot be null.");
        else if (acceptedConsentOnly !== undefined)
            url_ += "acceptedConsentOnly=" + encodeURIComponent("" + acceptedConsentOnly) + "&";
        if (activatedOnly === null)
            throw new globalThis.Error("The parameter 'activatedOnly' cannot be null.");
        else if (activatedOnly !== undefined)
            url_ += "activatedOnly=" + encodeURIComponent("" + activatedOnly) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (qSearch !== undefined && qSearch !== null)
            url_ += "qSearch=" + encodeURIComponent("" + qSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDTechRemoteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDTechRemoteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedRemoteServiceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedRemoteServiceListDto>;
        }));
    }

    protected processGetDTechRemoteList(response: HttpResponseBase): Observable<PagedRemoteServiceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedRemoteServiceListDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportDTechRemoteList(format: RemoteServiceListExportFormat | undefined, runningOnly: boolean | undefined, connectedOnly: boolean | undefined, acceptedConsentOnly: boolean | undefined, activatedOnly: boolean | undefined, qSearch: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DTechRemote/export?";
        if (format === null)
            throw new globalThis.Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (runningOnly === null)
            throw new globalThis.Error("The parameter 'runningOnly' cannot be null.");
        else if (runningOnly !== undefined)
            url_ += "runningOnly=" + encodeURIComponent("" + runningOnly) + "&";
        if (connectedOnly === null)
            throw new globalThis.Error("The parameter 'connectedOnly' cannot be null.");
        else if (connectedOnly !== undefined)
            url_ += "connectedOnly=" + encodeURIComponent("" + connectedOnly) + "&";
        if (acceptedConsentOnly === null)
            throw new globalThis.Error("The parameter 'acceptedConsentOnly' cannot be null.");
        else if (acceptedConsentOnly !== undefined)
            url_ += "acceptedConsentOnly=" + encodeURIComponent("" + acceptedConsentOnly) + "&";
        if (activatedOnly === null)
            throw new globalThis.Error("The parameter 'activatedOnly' cannot be null.");
        else if (activatedOnly !== undefined)
            url_ += "activatedOnly=" + encodeURIComponent("" + activatedOnly) + "&";
        if (qSearch !== undefined && qSearch !== null)
            url_ += "qSearch=" + encodeURIComponent("" + qSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDTechRemoteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDTechRemoteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportDTechRemoteList(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDTechRemoteById(remoteServiceId: string): Observable<RemoteServiceListItemDto> {
        let url_ = this.baseUrl + "/DTechRemote/{remoteServiceId}";
        if (remoteServiceId === undefined || remoteServiceId === null)
            throw new globalThis.Error("The parameter 'remoteServiceId' must be defined.");
        url_ = url_.replace("{remoteServiceId}", encodeURIComponent("" + remoteServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDTechRemoteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDTechRemoteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoteServiceListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoteServiceListItemDto>;
        }));
    }

    protected processGetDTechRemoteById(response: HttpResponseBase): Observable<RemoteServiceListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RemoteServiceListItemDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDTechRemoteService(vin: string | undefined): Observable<AddRemoteServiceDto> {
        let url_ = this.baseUrl + "/DTechRemote/add?";
        if (vin === null)
            throw new globalThis.Error("The parameter 'vin' cannot be null.");
        else if (vin !== undefined)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDTechRemoteService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDTechRemoteService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddRemoteServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddRemoteServiceDto>;
        }));
    }

    protected processAddDTechRemoteService(response: HttpResponseBase): Observable<AddRemoteServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddRemoteServiceDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    initiateDTechRemoteSession(remoteServiceId: string, command: InitiateDTechRemoteSessionCommand): Observable<void> {
        let url_ = this.baseUrl + "/DTechRemote/{remoteServiceId}/initiate";
        if (remoteServiceId === undefined || remoteServiceId === null)
            throw new globalThis.Error("The parameter 'remoteServiceId' must be defined.");
        url_ = url_.replace("{remoteServiceId}", encodeURIComponent("" + remoteServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitiateDTechRemoteSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitiateDTechRemoteSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInitiateDTechRemoteSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminateDTechRemoteSession(remoteServiceId: string, command: TerminateDTechRemoteSessionCommand): Observable<void> {
        let url_ = this.baseUrl + "/DTechRemote/{remoteServiceId}/terminate";
        if (remoteServiceId === undefined || remoteServiceId === null)
            throw new globalThis.Error("The parameter 'remoteServiceId' must be defined.");
        url_ = url_.replace("{remoteServiceId}", encodeURIComponent("" + remoteServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminateDTechRemoteSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminateDTechRemoteSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTerminateDTechRemoteSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRemoteServiceConsentService {
    getPendingConsents(organizationId: string | undefined): Observable<RemoteServiceConsentDto[]>;
    getCustomerConsent(remoteServiceId: string, kind: RemoteServiceKind | undefined): Observable<RemoteServiceConsentDto>;
    createCustomerConsent(remoteServiceId: string, kind: RemoteServiceKind | undefined, ttlMinutes: number | null | undefined, bypassCustomerConsentAcceptance: boolean | undefined): Observable<RemoteServiceConsentDto>;
    decideCustomerConsent(kind: RemoteServiceKind, consentId: string, organizationId: string | null | undefined, request: RemoteServiceConsentDecisionRequest): Observable<RemoteServiceConsentDto>;
}

@Injectable({
    providedIn: 'root'
})
export class RemoteServiceConsentService implements IRemoteServiceConsentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REMOTE_SERVICES_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPendingConsents(organizationId: string | undefined): Observable<RemoteServiceConsentDto[]> {
        let url_ = this.baseUrl + "/RemoteServiceConsent/pending?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingConsents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingConsents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoteServiceConsentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoteServiceConsentDto[]>;
        }));
    }

    protected processGetPendingConsents(response: HttpResponseBase): Observable<RemoteServiceConsentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RemoteServiceConsentDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerConsent(remoteServiceId: string, kind: RemoteServiceKind | undefined): Observable<RemoteServiceConsentDto> {
        let url_ = this.baseUrl + "/RemoteServiceConsent/{remoteServiceId}?";
        if (remoteServiceId === undefined || remoteServiceId === null)
            throw new globalThis.Error("The parameter 'remoteServiceId' must be defined.");
        url_ = url_.replace("{remoteServiceId}", encodeURIComponent("" + remoteServiceId));
        if (kind === null)
            throw new globalThis.Error("The parameter 'kind' cannot be null.");
        else if (kind !== undefined)
            url_ += "kind=" + encodeURIComponent("" + kind) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerConsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerConsent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoteServiceConsentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoteServiceConsentDto>;
        }));
    }

    protected processGetCustomerConsent(response: HttpResponseBase): Observable<RemoteServiceConsentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RemoteServiceConsentDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCustomerConsent(remoteServiceId: string, kind: RemoteServiceKind | undefined, ttlMinutes: number | null | undefined, bypassCustomerConsentAcceptance: boolean | undefined): Observable<RemoteServiceConsentDto> {
        let url_ = this.baseUrl + "/RemoteServiceConsent/{remoteServiceId}?";
        if (remoteServiceId === undefined || remoteServiceId === null)
            throw new globalThis.Error("The parameter 'remoteServiceId' must be defined.");
        url_ = url_.replace("{remoteServiceId}", encodeURIComponent("" + remoteServiceId));
        if (kind === null)
            throw new globalThis.Error("The parameter 'kind' cannot be null.");
        else if (kind !== undefined)
            url_ += "kind=" + encodeURIComponent("" + kind) + "&";
        if (ttlMinutes !== undefined && ttlMinutes !== null)
            url_ += "ttlMinutes=" + encodeURIComponent("" + ttlMinutes) + "&";
        if (bypassCustomerConsentAcceptance === null)
            throw new globalThis.Error("The parameter 'bypassCustomerConsentAcceptance' cannot be null.");
        else if (bypassCustomerConsentAcceptance !== undefined)
            url_ += "bypassCustomerConsentAcceptance=" + encodeURIComponent("" + bypassCustomerConsentAcceptance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomerConsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomerConsent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoteServiceConsentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoteServiceConsentDto>;
        }));
    }

    protected processCreateCustomerConsent(response: HttpResponseBase): Observable<RemoteServiceConsentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RemoteServiceConsentDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    decideCustomerConsent(kind: RemoteServiceKind, consentId: string, organizationId: string | null | undefined, request: RemoteServiceConsentDecisionRequest): Observable<RemoteServiceConsentDto> {
        let url_ = this.baseUrl + "/RemoteServiceConsent/consents/{kind}/{consentId}/decision?";
        if (kind === undefined || kind === null)
            throw new globalThis.Error("The parameter 'kind' must be defined.");
        url_ = url_.replace("{kind}", encodeURIComponent("" + kind));
        if (consentId === undefined || consentId === null)
            throw new globalThis.Error("The parameter 'consentId' must be defined.");
        url_ = url_.replace("{consentId}", encodeURIComponent("" + consentId));
        if (organizationId !== undefined && organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecideCustomerConsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecideCustomerConsent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoteServiceConsentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoteServiceConsentDto>;
        }));
    }

    protected processDecideCustomerConsent(response: HttpResponseBase): Observable<RemoteServiceConsentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RemoteServiceConsentDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRemoteServiceInternalService {
    publishDTechRemoteCustomerConsentUpdated(request: PublishRemoteServiceConsentUpdatedRequest): Observable<void>;
    publishRemoteSupportCustomerConsentUpdated(request: PublishRemoteServiceConsentUpdatedRequest): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RemoteServiceInternalService implements IRemoteServiceInternalService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REMOTE_SERVICES_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    publishDTechRemoteCustomerConsentUpdated(request: PublishRemoteServiceConsentUpdatedRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/remote-diagnostic/internal/customer-consent-updated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishDTechRemoteCustomerConsentUpdated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishDTechRemoteCustomerConsentUpdated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublishDTechRemoteCustomerConsentUpdated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    publishRemoteSupportCustomerConsentUpdated(request: PublishRemoteServiceConsentUpdatedRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/remote-support/internal/customer-consent-updated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishRemoteSupportCustomerConsentUpdated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishRemoteSupportCustomerConsentUpdated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublishRemoteSupportCustomerConsentUpdated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRemoteSupportService {
    getRemoteSupportList(runningOnly: boolean | undefined, connectedOnly: boolean | undefined, acceptedConsentOnly: boolean | undefined, activatedOnly: boolean | undefined, page: number | undefined, pageSize: number | undefined, qSearch: string | null | undefined): Observable<PagedRemoteServiceListDto>;
    exportRemoteSupportList(format: RemoteServiceListExportFormat | undefined, runningOnly: boolean | undefined, connectedOnly: boolean | undefined, acceptedConsentOnly: boolean | undefined, activatedOnly: boolean | undefined, qSearch: string | null | undefined): Observable<FileResponse>;
    getRemoteSupportById(remoteServiceId: string): Observable<RemoteServiceListItemDto>;
    addRemoteSupportService(vin: string | undefined): Observable<AddRemoteServiceDto>;
    initiateRemoteSupportSession(remoteServiceId: string, command: InitiateRemoteSupportSessionCommand): Observable<InitiateRemoteSupportSessionDto>;
    terminateRemoteSupportSession(remoteServiceId: string, command: TerminateRemoteSupportSessionCommand): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RemoteSupportService implements IRemoteSupportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_REMOTE_SERVICES_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getRemoteSupportList(runningOnly: boolean | undefined, connectedOnly: boolean | undefined, acceptedConsentOnly: boolean | undefined, activatedOnly: boolean | undefined, page: number | undefined, pageSize: number | undefined, qSearch: string | null | undefined): Observable<PagedRemoteServiceListDto> {
        let url_ = this.baseUrl + "/RemoteSupport?";
        if (runningOnly === null)
            throw new globalThis.Error("The parameter 'runningOnly' cannot be null.");
        else if (runningOnly !== undefined)
            url_ += "runningOnly=" + encodeURIComponent("" + runningOnly) + "&";
        if (connectedOnly === null)
            throw new globalThis.Error("The parameter 'connectedOnly' cannot be null.");
        else if (connectedOnly !== undefined)
            url_ += "connectedOnly=" + encodeURIComponent("" + connectedOnly) + "&";
        if (acceptedConsentOnly === null)
            throw new globalThis.Error("The parameter 'acceptedConsentOnly' cannot be null.");
        else if (acceptedConsentOnly !== undefined)
            url_ += "acceptedConsentOnly=" + encodeURIComponent("" + acceptedConsentOnly) + "&";
        if (activatedOnly === null)
            throw new globalThis.Error("The parameter 'activatedOnly' cannot be null.");
        else if (activatedOnly !== undefined)
            url_ += "activatedOnly=" + encodeURIComponent("" + activatedOnly) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (qSearch !== undefined && qSearch !== null)
            url_ += "qSearch=" + encodeURIComponent("" + qSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRemoteSupportList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemoteSupportList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedRemoteServiceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedRemoteServiceListDto>;
        }));
    }

    protected processGetRemoteSupportList(response: HttpResponseBase): Observable<PagedRemoteServiceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedRemoteServiceListDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportRemoteSupportList(format: RemoteServiceListExportFormat | undefined, runningOnly: boolean | undefined, connectedOnly: boolean | undefined, acceptedConsentOnly: boolean | undefined, activatedOnly: boolean | undefined, qSearch: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/RemoteSupport/export?";
        if (format === null)
            throw new globalThis.Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (runningOnly === null)
            throw new globalThis.Error("The parameter 'runningOnly' cannot be null.");
        else if (runningOnly !== undefined)
            url_ += "runningOnly=" + encodeURIComponent("" + runningOnly) + "&";
        if (connectedOnly === null)
            throw new globalThis.Error("The parameter 'connectedOnly' cannot be null.");
        else if (connectedOnly !== undefined)
            url_ += "connectedOnly=" + encodeURIComponent("" + connectedOnly) + "&";
        if (acceptedConsentOnly === null)
            throw new globalThis.Error("The parameter 'acceptedConsentOnly' cannot be null.");
        else if (acceptedConsentOnly !== undefined)
            url_ += "acceptedConsentOnly=" + encodeURIComponent("" + acceptedConsentOnly) + "&";
        if (activatedOnly === null)
            throw new globalThis.Error("The parameter 'activatedOnly' cannot be null.");
        else if (activatedOnly !== undefined)
            url_ += "activatedOnly=" + encodeURIComponent("" + activatedOnly) + "&";
        if (qSearch !== undefined && qSearch !== null)
            url_ += "qSearch=" + encodeURIComponent("" + qSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRemoteSupportList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRemoteSupportList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportRemoteSupportList(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRemoteSupportById(remoteServiceId: string): Observable<RemoteServiceListItemDto> {
        let url_ = this.baseUrl + "/RemoteSupport/{remoteServiceId}";
        if (remoteServiceId === undefined || remoteServiceId === null)
            throw new globalThis.Error("The parameter 'remoteServiceId' must be defined.");
        url_ = url_.replace("{remoteServiceId}", encodeURIComponent("" + remoteServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRemoteSupportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemoteSupportById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoteServiceListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoteServiceListItemDto>;
        }));
    }

    protected processGetRemoteSupportById(response: HttpResponseBase): Observable<RemoteServiceListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RemoteServiceListItemDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addRemoteSupportService(vin: string | undefined): Observable<AddRemoteServiceDto> {
        let url_ = this.baseUrl + "/RemoteSupport/add?";
        if (vin === null)
            throw new globalThis.Error("The parameter 'vin' cannot be null.");
        else if (vin !== undefined)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRemoteSupportService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRemoteSupportService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddRemoteServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddRemoteServiceDto>;
        }));
    }

    protected processAddRemoteSupportService(response: HttpResponseBase): Observable<AddRemoteServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddRemoteServiceDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    initiateRemoteSupportSession(remoteServiceId: string, command: InitiateRemoteSupportSessionCommand): Observable<InitiateRemoteSupportSessionDto> {
        let url_ = this.baseUrl + "/RemoteSupport/{remoteServiceId}/initiate";
        if (remoteServiceId === undefined || remoteServiceId === null)
            throw new globalThis.Error("The parameter 'remoteServiceId' must be defined.");
        url_ = url_.replace("{remoteServiceId}", encodeURIComponent("" + remoteServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitiateRemoteSupportSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitiateRemoteSupportSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InitiateRemoteSupportSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InitiateRemoteSupportSessionDto>;
        }));
    }

    protected processInitiateRemoteSupportSession(response: HttpResponseBase): Observable<InitiateRemoteSupportSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InitiateRemoteSupportSessionDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminateRemoteSupportSession(remoteServiceId: string, command: TerminateRemoteSupportSessionCommand): Observable<void> {
        let url_ = this.baseUrl + "/RemoteSupport/{remoteServiceId}/terminate";
        if (remoteServiceId === undefined || remoteServiceId === null)
            throw new globalThis.Error("The parameter 'remoteServiceId' must be defined.");
        url_ = url_.replace("{remoteServiceId}", encodeURIComponent("" + remoteServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminateRemoteSupportSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminateRemoteSupportSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTerminateRemoteSupportSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface PagedRemoteServiceListDto {
    remoteServices?: RemoteServiceListItemDto[] | null;
    start?: number;
    limit?: number;
    total?: number;
}

export interface RemoteServiceListItemDto {
    id?: string;
    vin?: string;
    ctmStatus?: CtmStatus;
    sessionStatus?: string | null;
    lastPositionUpdate?: string | null;
    isRunning?: boolean;
    activated?: boolean | null;
    organizationName?: string | null;
    organizationEmail?: string | null;
    customerName?: string | null;
    vehicleModel?: string | null;
    vehiclePicture?: string | null;
    consentStatus?: string | null;
    consentExp?: string | null;
}

export enum CtmStatus {
    NOT_FOUND = 0,
    EXPIRED = 1,
    EXPIRING = 2,
    VALID = 3,
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export enum RemoteServiceListExportFormat {
    Csv = 0,
    Xlsx = 1,
}

export interface AddRemoteServiceDto {
    id?: string;
    vin: string;
}

export interface InitiateDTechRemoteSessionCommand {
    vin: string;
    jwtAccessToken?: string | null;
    userId?: string | null;
}

export interface TerminateDTechRemoteSessionCommand {
    vin?: string;
}

export interface RemoteServiceConsentDto {
    id?: string;
    remoteServiceId?: string;
    vin?: string;
    remoteServiceKind?: string;
    dealerUserId?: string;
    dealerName?: string;
    requesterContactName?: string;
    requesterContactEmail?: string;
    requestedAt?: string;
    expiresAt?: string;
    status?: string;
    respondedAt?: string | null;
    respondedByUserId?: string | null;
}

export enum RemoteServiceKind {
    DTechRemote = 0,
    RemoteSupport = 1,
}

export interface RemoteServiceConsentDecisionRequest {
    decision?: string;
}

export interface PublishRemoteServiceConsentUpdatedRequest {
    consentId?: string;
    assistanceId?: string;
    vin?: string;
    status?: string;
    expiresAt?: string;
    respondedAt?: string | null;
    respondedByUserId?: string | null;
}

export interface InitiateRemoteSupportSessionDto {
    assistanceId?: string;
    vin?: string;
    launchUrl?: string;
    issuedAtUtc?: string;
    expiresAtUtc?: string;
}

export interface InitiateRemoteSupportSessionCommand {
    vin?: string;
}

export interface TerminateRemoteSupportSessionCommand {
    vin?: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}